import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface CalloutProps {
  children: ReactNode;
  title?: string;
  /** `caveat` marks the limits stated plainly rather than buried. */
  tone?: 'accent' | 'caveat';
  className?: string;
}

export function Callout({ children, title, tone = 'accent', className }: CalloutProps) {
  return (
    <div
      className={cn(
        'rounded-xl border p-4 sm:p-5',
        tone === 'accent' && 'border-indigo-400/25 bg-indigo-500/[0.07]',
        tone === 'caveat' && 'border-slate-600/50 bg-slate-800/50',
        className
      )}
    >
      {title && (
        <p
          className={cn(
            'mb-1.5 text-[11px] font-semibold uppercase tracking-wider',
            tone === 'accent' ? 'text-indigo-300' : 'text-slate-500'
          )}
        >
          {title}
        </p>
      )}
      <div className="text-[13px] leading-relaxed text-slate-300 sm:text-sm">{children}</div>
    </div>
  );
}
